export const formatDate = value => {
  if (!value) {
    return '';
  } else {
    const options = {
      day: 'numeric',
      year: 'numeric',
      month: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    };
    return new Intl.DateTimeFormat('en-gb', options).format(new Date(value));
  }
};
